import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { sv } from "date-fns/locale";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addStaticTimeToDate } from "../../util/formats";
import { useEffect, useState } from "react";

export function UpdateCarePrincipalModal() {
  const { handleSubmit } = useForm();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const listItem = useSelector((state: any) => state.carePrincipal.item);

  const [dateValue, setDateValue] = useState<Date | null>();

  const carePrincipalId = useSelector(
    (state: any) => state.carePrincipal.carePrincipal.carePrincipalId
  );

  useEffect(() => {
    if (listItem.expireDate === null || listItem.expireDate === undefined) {
      setDateValue(null);
    } else {
      setDateValue(listItem.expireDate);
    }
  }, [listItem]);

  const onSubmit = () => {
    const updatedAccess = {
      id: listItem.id,
      idType: listItem.idType,
      expireDate: dateValue ? addStaticTimeToDate(dateValue) : undefined,
    };
    dispatch({
      type: "UPDATE_CARE_PRINCIPAL_ACCESS",
      updatedAccess,
      carePrincipalId,
    });
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle sx={{ fontWeight: "bold" }} id="alert-dialog-title">
          Uppdatera {listItem.idType === "System" ? "system" : "vårdgivare"}
        </DialogTitle>
        <DialogContent>
          <Stack direction="row" spacing={4}>
            <Typography sx={{ fontWeight: "bold" }}>
              {listItem.idType === "System"
                ? "System HSA-Id"
                : "Vårdgivarens HSA-Id"}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={4} sx={{ paddingBottom: 2 }}>
            <Typography>{listItem.id}</Typography>
          </Stack>
          <LocalizationProvider adapterLocale={sv} dateAdapter={AdapterDateFns}>
            <DatePicker
              label={t("date")}
              mask=""
              value={dateValue}
              onChange={setDateValue}
              renderInput={(params: any) => (
                <TextField
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    placeholder: t("dateFormat"),
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => dispatch({ type: "MODAL_CANCEL" })}
          >
            {t("cancel")}
          </Button>
          <Button variant="contained" color="success" type="submit">
            {t("edit")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
